module.exports = __webpack_public_path__ + "static/media/china.7ab08c89.svg";